import { authRoles } from 'app/auth';
import CaptchaToGenerateEditForm from './editform/CaptchaToGenerateEditForm';
import CaptchaToGenerateTable from './table/CaptchaToGenerateTable';

export default [
	{
		path: '/captchatogenerate/edit/:id',
		component: CaptchaToGenerateEditForm,
		auth: authRoles.userAccount
	},
	{
		path: '/captchatogenerate/:sessionNameParam?',
		component: CaptchaToGenerateTable,
		auth: authRoles.userAccount
	}
];
